import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IDepartamento } from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class DepartamentoService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/departamento`;
  }

  getDepartamentos(paisId: number): Observable<IDepartamento[]> {
    return this.http.get<IDepartamento[]>(`${this.baseUrl}/public/${paisId}`);
  }
}
